import { useDropzone } from "react-dropzone";
import { Box, Button, Flex, useToast, Text } from "@chakra-ui/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import trainerRegistration from "../../services/trainer/trainerRegistration";
import { useNavigate } from "react-router-dom";
import trainerRoutes from "../../pages/trainer/routes";
import { Document, Page } from "react-pdf";

const CvUpload = ({ nextPage, ...rest }: { nextPage: any }) => {
  const toast = useToast();
  const navigate = useNavigate();

  const [batchFile, setbatchFile] = useState<File | null>(null);
  const [cv, setcv] = useState<any>();
  const [filename, setFilename] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: any }) {
    setNumPages(numPages);
  }
  useEffect(() => {
    trainerRegistration.getCv().then((res) => {
      setcv(res.data.doc);
    });
  }, []);

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: "File Upload",
        description: "Invalid file uploaded",
        status: "error",
      });
      setbatchFile(null);
    } else {
      const formData = new FormData();
      const file = acceptedFiles[0];

      formData.append("doc", file);
      setbatchFile(file);
      setFilename(file.name);
      toast({
        title: "File Upload",
        description: "Your file is ready for upload",
        status: "success",
      });
    }
  }, []);
  const submitCV = async () => {
    const formData = new FormData();
    if (batchFile) {
      const file = batchFile;

      formData.append("doc", file, file.name);
      try {
        const cvupload = await trainerRegistration.uploadCv(formData);
        if (cvupload) {
          toast({
            title: "Registration",
            description: "CV uploaded successfully",
            status: "success",
          });
        }
      } catch (error) {
        toast({
          title: "Registration",
          description: "something went wrong, try again later",
          status: "error",
        });
      }
    }
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <>
      <Box mx="auto" width={{ md: "auto", sm: "100%", base: "100%" }}>
        <Flex justifyContent="center">
          <Text mb="33px" fontWeight="700" color="#2B2B2B" fontSize={["22px","30px"]}>
            Upload CV/Resume
          </Text>
        </Flex>
        <Text color="#959595" mb="20px" fontSize="14px">
          Upload an image/pdf of your resume here. (Not larger than 2MB)
        </Text>

        {cv && (
          <Text color="#000000" mb="20px" fontSize="14px">
            CV : {cv}
          </Text>
        )}
        <form>
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drop the files here ...</p>
            ) : (
              <p>Click here or drag and drop your file </p>
            )}
          </div>
          {filename && (
            <Text fontWeight="400" color="#959595" fontSize="12px">
              {filename}
            </Text>
          )}
          <Flex justifyContent="center">
            <Button
              mt={4}
              onClick={() => {
                submitCV();
                navigate(trainerRoutes.Dashboard);
              }}
              colorScheme="red"
              size="md"
              px={4}
              fontSize="14px"
              borderRadius="0px"
            >
              {" "}
              SAVE CHANGES
            </Button>
          </Flex>
        </form>
      </Box>
    </>
  );
};

export default CvUpload;
